import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';

import { Observable   } from 'rxjs';
import { EventService } from '../../../core/services/event.service';

@Component({
  selector: 'app-simple-ms',
  templateUrl: './simple-ms.component.html',
  styleUrls: ['./simple-ms.component.scss']
})
export class SimpleMsComponent implements OnInit {

  @Input()  WsData: any;
  @Input() Origen; string;
  @Output() CerrarMsInterno = new EventEmitter<boolean>();

  ToolbarMS : any;
  Navs: any;
  form_template$: Observable<any>;
  myDate : any  = new Date();
  DatosResp : any;
  strModo : string = '';
  strEventListener : string = '';
  EventoCerrarMSNavID : string = '';
  DataReporte : any;
  SYS02JAV : string = '';
  FormID     : string = '';
  strModoCampo : String = '';
  encabezado: any;
  SYS02CON : number;
  Reportes : any;
  WORKFLOW : any;
  DOC10ARC : any;
  PRO10ARC : any;
  WsLlaves : any;
  AccionesOnChange : any;
  SYS41ARC : any;
  mostrarCampo: boolean = true;

  constructor(private dataService:  SharedService,
              private eventService: EventService) {
  }

  ngOnInit(): void {    
    this.CargarDatos();
  }

  CargarDatos(): void {
    this.WsLlaves = this.WsData.LLAVES[0];
    this.strModo = this.WsData.OPERACION;
    this.EventoCerrarMSNavID = this.WsData.NAV_ID;
        if (this.strModo == "ABRIR_REPORTE_PDF") {
          // Voy a mostrar un reporte PDF en un NAV nuevo
          this.dataService.ConsultarWS(this.WsData.URL, this.WsData).subscribe (
            (datosResp: any) => {
              this.DataReporte = datosResp.DATA[0].REPORTE_PDF_BASE64;
            },
            error => {
              Swal.fire({
                title: 'Error',
                text: error,
                icon: 'error',
              })
            }
          );
        } else {
          this.dataService.ConsultarWS(this.WsData.URL, this.WsData).subscribe (
            (datosResp: any) => {
                 this.DatosResp = datosResp;
                if (this.DatosResp == null)
                  // almora : No pude mostrar este alert como error con el Swal de abajo
                  alert ("Error: No se ha recibido información de respuesta. [" + this.WsData.URL + "]");
                this.strModoCampo = datosResp.Modo;
                this.encabezado = datosResp.Encabezado;
                this.SYS02CON = datosResp.SYS02CON;
                this.Navs = datosResp.Navs;
                this.ToolbarMS = datosResp.Toolbar;
                this.strEventListener =  datosResp.SYS02CON;
                this.form_template$ = this.retornaObservable(datosResp.CamposMS);
                this.FormID  = datosResp.FORM_ID;
                this.Reportes = datosResp.Reportes;
                this.WORKFLOW = datosResp.WORKFLOW;
                this.DOC10ARC = datosResp.DOC10ARC;
                this.PRO10ARC = datosResp.PRO10ARC;
                this.AccionesOnChange = datosResp.AccionesOnChange;
                if (datosResp.SYS02JAV !== "undefined")
                  this.SYS02JAV = atob(datosResp.SYS02JAV);
                if (datosResp.SYS41ARC !== "undefined")
                  this.SYS41ARC = datosResp.SYS41ARC;

                this.mostrarCampo = true;
            },
            error => {
              this.CerrarMsInterno.emit(false);
              Swal.fire({
                title: 'Error',
                text: error,
                icon: 'error',
              })
            }
          );
        }
  }

  retornaObservable(form_template) {
    const obs$ = new Observable(observer => {
      observer.next(form_template);
    });
    return obs$;
  }

  RecargarFormulario(datosResp?: any) {
    this.mostrarCampo = false;   // Destruye app-campo / dispara ngOnDestroy
    setTimeout(() => {
      this.CargarDatos();        // Reset / dispara ngOnInit completo
    });
  }

  EventoCerrarSimpleMsInterno(blnRefrescar:boolean){
    this.CerrarMsInterno.emit(blnRefrescar);
  }


}
